import React from 'react';
import PropTypes from 'prop-types';
import * as ActionTypes from '@/stores/sale/actions';
import { withApi } from '@tencent/react-aio';
import { connect } from 'react-redux';

// 渲染 OrderingProduct 组件

let list = [];

class OrderingProduct extends React.Component {
  static propTypes = {
    id: PropTypes.number,
    webApi: PropTypes.object.isRequired,
  }

  state = { productList: [], productListKV: {} }

  componentDidMount() {
    const { webApi } = this.props;
    const { productList } = this.state;
    if (list.length === 0) {
      webApi
        .getOrderingProductList()
        .dispatchJson(ActionTypes.FETCH_ORDERING_PRODUCT_LIST)
        .then(
          (resp) => {
            list = resp;
            const obj = {};
            resp.forEach((item) => (
              obj[item.orderingProductId] = item.orderingProductName
            ));
            this.setState({
              productList: resp,
              productListKV: obj,
            });
          },
          (error) => {
            this.context.error('获取自定义列失败', error.message);
          },
        );
    } else {
      let productListKV = {};
      list.forEach((item) => (
        productListKV[item.orderingProductId] = item.orderingProductName
      ));
      this.setState({
        productList: list,
        productListKV,
      });
    }
  }

  render() {
    const { id } = this.props;
    const { productListKV } = this.state;
    let data = '';

    if (Array.isArray(id)) {
      data = id.map((item) => productListKV[item]).join(',');
    } else {
      data = productListKV[id];
    }

    return <span>{data || '-'}</span>;
  }
}

function mapStateToProps(state, ownProps) {
  return {
    productList: state.productList,
  };
}

export default withApi(connect(mapStateToProps)(OrderingProduct));
